import { render, staticRenderFns } from "./StudentBookings.vue?vue&type=template&id=74f8e0ef"
import script from "./StudentBookings.vue?vue&type=script&lang=js"
export * from "./StudentBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports